if (!customElements.get('v3-benefits')) {
  class V3Benefits extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-modal-target]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.modalTarget);
          if (!dialog) return;
          dialog.showModal();
          this.scrollToAnchor(dialog, button.dataset.modalAnchor);
        });
      });

      this.querySelectorAll('dialog.v3-benefits__modal').forEach((dialog) => {
        const closeButton = dialog.querySelector('.v3-benefits__modal-close');
        if (closeButton) closeButton.addEventListener('click', () => dialog.close());

        // A click on the backdrop targets the <dialog> element itself.
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          const button = event.target.querySelector('[data-modal-target]');
          if (!button) return;
          const dialog = document.getElementById(button.dataset.modalTarget);
          if (dialog && !dialog.open) dialog.showModal();
        });
        document.addEventListener('shopify:block:deselect', (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          this.querySelectorAll('dialog.v3-benefits__modal[open]').forEach((dialog) => dialog.close());
        });
      }
    }
  }
  V3Benefits.prototype.scrollToAnchor = function (dialog, anchor) {
    const card = dialog.querySelector('.v3-benefits__modal-card');
    if (!card) return;
    if (!anchor) {
      card.scrollTop = 0;
      return;
    }
    const content = dialog.querySelector('[data-modal-page-content]') || card;
    const needle = anchor.trim().toLowerCase();
    let target = null;
    try {
      target = content.querySelector('#' + CSS.escape(anchor.trim()));
    } catch (e) {
      target = null;
    }
    if (!target) {
      target = Array.from(content.querySelectorAll('h1, h2, h3, h4, h5, h6, strong')).find(
        (el) => el.textContent.trim().toLowerCase().includes(needle)
      );
    }
    if (target) {
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'smooth' }));
    } else {
      card.scrollTop = 0;
    }
  };

  customElements.define('v3-benefits', V3Benefits);
}
